import React, {useState} from 'react';
import {ImageBackground, StyleProp, Text, TouchableOpacity, View, ViewStyle} from 'react-native';
import {numberFormatToRub} from '../../../../shared/utils/numberFormatToRub';
import {formatDate} from '../../../../shared/utils/formatDate';
import {Certificate} from '../../../../shared/models/api/eCertificatesResponsePayload';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import backgroundImage from './background-image.svg';
import {useCertificateCardStyles} from './CertificateCard.style';

const image = {uri: backgroundImage};

interface CertificateCardProps
  extends Pick<Certificate, 'certificateType' | 'certificateNumber' | 'name' | 'endDate' | 'balance'> {
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

export function CertificateCard({
  certificateType,
  certificateNumber,
  name,
  endDate,
  balance,
  onPress,
  style,
}: CertificateCardProps) {
  const [height, setHeight] = useState(0);
  const styles = useCertificateCardStyles();

  const isDesktop = useIsDesktop();

  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.7} style={style}>
      <View style={styles.cardContainer}>
        {isDesktop && <ImageBackground source={image} resizeMode='cover' imageStyle={[styles.image, {height}]} />}
        <View
          style={styles.cardContent}
          onLayout={(event) => {
            setHeight(event.nativeEvent.layout.height);
          }}>
          <View style={{flexBasis: '30%'}}>
            <Text style={styles.columnTitle}>Рег. номер</Text>
            <Text style={styles.columnText}>{certificateNumber}</Text>
          </View>

          <View style={[styles.cardColumn, {flexBasis: '33%'}]}>
            <Text style={styles.columnTitle}>Наименование</Text>
            <Text style={styles.columnText}>{name}</Text>
          </View>

          {!isDesktop ? (
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                width: '100%',
              }}>
              <View>
                <Text style={styles.columnTitle}>Действует до</Text>
                <Text style={styles.columnText}>{formatDate(endDate)}</Text>
              </View>
              {certificateType !== 'ECTP0001' && (
                <View>
                  <Text style={styles.columnTitle}>Доступный остаток</Text>
                  <Text style={styles.balance}>{numberFormatToRub(balance) ?? '––'}</Text>
                </View>
              )}
            </View>
          ) : (
            <>
              {certificateType !== 'ECTP0001' && (
                <View style={{flexBasis: '31%'}}>
                  <Text style={styles.columnTitle}>Доступный остаток</Text>
                  <Text style={styles.balance}>{numberFormatToRub(balance) ?? '––'}</Text>
                </View>
              )}

              <View style={styles.cardColumn}>
                <Text style={styles.columnTitle}>Действует до</Text>
                <Text style={styles.columnText}>{formatDate(endDate)}</Text>
              </View>
            </>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
}
